import {
  bffServiceClient,
  ticketServiceClient,
} from '../../packages/request/clients';
import { getResult } from 'helpers/request';
import {
  IAssignTaskParams,
  IAssignTaskToStaffParams,
  IBodyCreateTask,
  IBulkCreateBySegmentParams,
  IGetIssueTypeParams,
  IGetIssueTypeResult,
  IGetWaitingTaskParams,
  IParamsUpdateTask,
  IParamsUpdateTaskAddProfileMC,
  ITaskParams,
  IResponseITaskDetail,
  IUpdateSposContractParams,
} from 'interfaces';

const getTasks = (params: ITaskParams) => {
  return ticketServiceClient.get('/issue_types', { params }).then(getResult);
};

const createTask = (data: any) => {
  return ticketServiceClient.post('/issue_types', data).then(getResult);
};

const updateTask = (data: any) => {
  return ticketServiceClient
    .put(`/issue_types/${data.issue_type_id}`, data)
    .then(getResult);
};

const updateTaskStatus = (taskId: number, isActive: boolean) => {
  return ticketServiceClient
    .put(`/issue_types/${taskId}`, {
      is_active: isActive,
    })
    .then(getResult);
};

const getWaitingTask = (params: IGetWaitingTaskParams) => {
  return bffServiceClient.get(`/ticket/waiting`, { params }).then(getResult);
};

const assignTask = (params: IAssignTaskParams) => {
  return bffServiceClient.post(`/ticket/upload`, params).then(getResult);
};

const assignTasktoStaff = (params: IAssignTaskToStaffParams) => {
  return bffServiceClient
    .put(`/ticket/${params.ticketId}/assign`, {
      ...params,
      ticketId: undefined,
    })
    .then(getResult);
};

const getIssueType = (
  params: IGetIssueTypeParams
): Promise<IGetIssueTypeResult> => {
  return bffServiceClient.get(`/issueType`, { params }).then(getResult);
};

const getTask = (id: string): Promise<IResponseITaskDetail> => {
  return bffServiceClient.get(`/ticket/` + id).then(getResult);
};

const updateTaskDetail = (id: string, params: IParamsUpdateTask) => {
  return bffServiceClient.put('/ticket/' + id, params);
};

const createApproachTicket = (body: IBodyCreateTask) => {
  return bffServiceClient.post('/ticket', body);
};

const updateTaskAddProfileMC = (payload: IParamsUpdateTaskAddProfileMC) => {
  return bffServiceClient.put('/ticket/updateMerchantContractMCA', payload);
};

const updateSposContract = (payload: IUpdateSposContractParams) => {
  return bffServiceClient.put('/ticket/additionalSposContract', payload);
};

const bulkCreateBySegment = (params: IBulkCreateBySegmentParams) => {
  return bffServiceClient
    .post('/ticket/bulk-create-by-segment', params)
    .then(getResult);
};

export default {
  getTasks,
  createTask,
  updateTask,
  updateTaskStatus,
  assignTask,
  getWaitingTask,
  getIssueType,
  getTask,
  updateTaskDetail,
  assignTasktoStaff,
  createApproachTicket,
  updateTaskAddProfileMC,
  updateSposContract,
  bulkCreateBySegment,
};
